import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ImportError = ({ error }) => {
    let rowErrors = [];
    let columns = [];
    try {
        rowErrors = JSON.parse(error);
        columns = rowErrors.length ? Object.keys(rowErrors[0].row) : [];
    }
    catch {
        // Do nothing
    }
    const getRowErrors = (rowErrors) => {
        const errors = [];
        rowErrors.forEach(rowError => {
            errors.push(`${rowError.loc.join('.')}: ${rowError.ctx?.error || rowError.msg}`);
        });
        return errors.join('<br />');
    };
    if (!rowErrors.length) {
        return (_jsx("pre", { className: 'text-sm border border-1 border-gray-700 bg-gray-300 p-3 overflow-auto', children: error }));
    }
    return (_jsx("div", { className: 'overflow-x-auto', children: _jsxs("table", { className: 'w-full', children: [_jsx("thead", { children: _jsxs("tr", { children: [columns.map(column => (_jsx("th", { className: 'border border-1 border-gray-700 p-3', children: column }, column))), _jsx("th", { className: 'border border-1 border-gray-700 p-3', children: "Error" }, 'error')] }) }), _jsx("tbody", { children: rowErrors.map(rowError => (_jsxs("tr", { children: [columns.map(column => (_jsx("td", { className: 'border border-1 border-gray-700 p-3', children: rowError.row[column] }, column))), _jsx("td", { className: 'border border-1 border-gray-700 p-3', children: _jsx("div", { dangerouslySetInnerHTML: { __html: getRowErrors(rowError.errors) } }) }, 'error')] }, rowError.row_num))) })] }) }));
};
